export default __webpack_public_path__ + "static/media/sg.f10f7273.svg";